import React, { forwardRef, ComponentPropsWithoutRef } from 'react';

type VideoProps = ComponentPropsWithoutRef<'video'>;

export const Video = forwardRef<HTMLVideoElement, VideoProps>(
  ({ ...props }, ref) => {
    return <video ref={ref} {...props} />;
  },
);

export default React.memo(Video);
